<template>
  <div>

    <div class="row">
      <div class="col-12 col-lg-6">
        <va-card>
          <div class="row">
            <div class="col">
              <h3>
                {{ $t('user.profile') }}&nbsp;
                <i @click.prevent="editUserProfile()" class="fa fa-pencil icon-color-evollu"></i>
              </h3>
            </div>

            <!-- Change Password va-button -->
            <div class="col">
              <div class="pull-right">
                <va-button class="btn btn-primary btn-micro" @click.prevent="showUpdatePasswordModal = true">
                  {{ $t('users.inputs.change_password') }}
                </va-button>
              </div>
            </div>
          </div>

          <!-- User Details Section -->
          <div class="row" v-if="userDetails">
            <div class="col-12">
              <div>
                <b class="profile-details-label">{{ $t('users.inputs.name') }}</b>
                <p>{{ userDetails.name }}</p>
              </div>
              <div>
                <b class="profile-details-label">{{ $t('users.inputs.email') }}</b>
                <p>{{ userDetails.email }}</p>
              </div>
              <div>
                <b class="profile-details-label">{{ $t('users.inputs.nickname') }}</b>
                <p>{{ userDetails.nickname }}</p>
              </div>
              <div>
                <b class="profile-details-label">{{ $t('users.inputs.entity') }}</b>
                <p>{{ userDetails.entity.name }}</p>
              </div>
              <div>
                <b class="profile-details-label">{{ $t('users.inputs.language') }}</b>
                <p>{{ selectedUserLanguage }}</p>
              </div>
            </div>
          </div>
        </va-card>
      </div>

      <div class="col-12 col-lg-6">
        <va-card style="height: calc(100% - 1.85rem);">
          <!--<div class="row">
            <div class="col-12">
              <h2>
                {{ $t('profile.labels.configurations') }}
              </h2>
            </div>
          </div>

          <div class="row">
            <span class="col">
                <p><b>{{ $t('profile.labels.sync_calendar') }}</b></p>
              </span>
            <div v-if="caldav && isEditingCaldav" class="col">
              <div class="pull-right">
                <slider v-model="caldav.active" @change="updateCaldavState"></slider>
              </div>
            </div>
          </div>
          <div class="row" v-if="caldav">
            <div class="col-12">
              <span class="d-flex">
                <span style="overflow:hidden;display:inline-block;text-overflow:ellipsis;line-height:1">
                  <p><a :href="caldavUrl">{{ caldavUrl }}</a></p>
                </span>
                <a href="" style="margin-left: 5px;"><i class="fa fa-copy" @click.prevent="copyCaldavUrl"></i></a>
              </span>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <span v-if="caldav">
                <p>{{ 'profile.calendar.generate_new' | translate }} <a href="#"
                                                                        @click.prevent="generateNewCaldav">{{
                    'profile.calendar.click_here' | translate
                  }}</a> {{
                    'profile.calendar.generate_msg' | translate
                  }}</p>
              </span>
              <span v-else>
                <p>{{ 'profile.calendar.without' | translate }}&nbsp;<a href="#" @click.prevent="createCaldav">{{
                    'profile.calendar.click_here' | translate
                  }}</a> {{ 'profile.calendar.generate' | translate }}</p>
              </span>
            </div>
          </div>-->

          <!-- User Details Section -->
          <div v-if="userHasScreeningActivity" class="section-body">
            <hr>
            <div class="section-title d-flex justify-content-between">
              <span>{{ $t('profile.labels.qr_code_notification') }}</span>
              <div v-if="screeningNotificationCreated" class="d-flex">
                <slider v-model="screening.active" @change="updateScreeningEmailNotification"></slider>
              </div>
            </div>
            <div class="section-content">
              <div v-if="screeningNotificationCreated">
                <span v-if="!isEditingScreeningDays"> {{ screeningNotificationMessage }} &nbsp;<i
                  v-if="screening.active" class="fa fa-pencil icon-color-evollu"
                  @click.prevent="editDaysBeforeNotification"></i></span>
                <span v-if="isEditingScreeningDays">
                  <div class="form-group form-group-value"
                       :class="{'has-error': !validScreeningNotificationDaysBefore, 'valid': validScreeningNotificationDaysBefore && daysBefore}">
                    <div class="input-group">
                      <va-input
                        type="number"
                        step="1"
                        v-model="daysBefore"
                        id="name-input"
                        :label="$t('profile.inputs.num_days_before')"
                        required/>
                      <small v-show="!validScreeningNotificationDaysBefore && daysBefore != ''"
                             class="help text-danger">
                        {{ $t('profile.errors.invalid_days_before') }}
                      </small>
                    </div>
                  </div>
                  <div
                    class="d-flex flex-column justify-content-center align-items-start flex-md-row justify-content-md-between">
                    <va-button class="btn btn-primary btn-micro btn-screening-notification-action"
                               @click.prevent="cancelUpdateNumberDays()">
                      {{ $t('modals.va-buttons.cancel') }}
                    </va-button>
                    <va-button :disabled="!validScreeningNotificationDaysBefore"
                               class="btn btn-primary btn-micro btn-screening-notification-action"
                               @click.prevent="submitUpdateNumberDays()">
                      {{ $t('modals.va-buttons.save') }}
                    </va-button>
                  </div>
                </span>
              </div>
              <span v-else>
                {{ $t('profile.labels.without_screening_notification') }}&nbsp;
                <a href="#"
                   @click.prevent="updateScreeningEmailNotification">{{ 'profile.calendar.click_here' | translate }}</a> {{
                  $t('profile.labels.generate_screening_configuration')
                }}</span>
            </div>
          </div>
        </va-card>
      </div>
    </div>

    <!--<div class="row">
      <div class="col-12">
        <va-card>
          <notifications :show-preview-toggle="true"/>
        </va-card>
      </div>
    </div>-->

    <!-- Roles section -->
    <div class="row" v-if="userDetails">
      <div class="col-12">
        <va-card>
          <UserRoleDetails
            class="mb-3"
            :showTitle="true"
            :userId="userDetails.id"
            :entityId="userDetails.entity.id"
            :limitItems="7"
            @showEntitiesForRoleModal="showEntitiesForRoleModal"
            @showRolesForEntityModal="showRolesForEntityModal"
          />
        </va-card>
      </div>
    </div>

    <div class="row">
      <div class="col-12">

        <!-- Delete Account Section -->
        <va-card>
          <div class="row">
            <div class="col-12">
              <!-- <h2 style="color: #cb2431;">{{'users.delete_account'| translate}}&nbsp; -->
              <h5>{{ 'users.delete_account'| translate }}&nbsp;
                <a href="#" @click.prevent="expandDeleteAccount = !expandDeleteAccount">
                  <i style="color: #cb2431;" class="fa fa-chevron-down"></i>
                </a>
                <!-- </h2> -->
              </h5>
            </div>
          </div>
          <div></div>
          <div v-if="!expandDeleteAccount" class="row">
            <br>
            <div class="delete-account-wrapper col-12">
              <p>{{ 'users.delete_account_msg' | translate }}</p>
            </div>
            <br>
            <div class="col-12">
              <va-button
                color="danger"
                class="button-no-margin-left"
                @click="confirmDelete">
                {{ 'users.delete'| translate }}
              </va-button>
            </div>
          </div>
        </va-card>
      </div>
    </div>

    <va-modal v-model="deleteClicked" :show.sync="deleteClicked" :noOutsideDismiss="true" ref="deleteAccountModal"
              :okText="'users.delete' | translate" :cancelText="'agenda.cancel' | translate"
              okClass="btn btn-danger btn-micro" cancelClass="btn-cancelar btn btn-primary btn-micro"
              @cancel="cancelDeleteAccount" @ok="confirmDeleteAccount">
      <div slot="title" class="is-bold">{{ 'users.delete_account' | translate }}
      </div>
      <div>
        <span class="is-bold">{{ 'users.delete_account_msg' | translate }}</span>
      </div>
    </va-modal>

    <edit-user-profile-modal v-if="isUpdatingProfile" :show="isUpdatingProfile"
                             @cancel-update="isUpdatingProfile = false"
                             @profile-updated="profileUpdated"></edit-user-profile-modal>
    <EditUserPasswordModal v-if="showUpdatePasswordModal"
                           @cancel="showUpdatePasswordModal = false"
                           @password-updated="passwordUpdated"/>

    <EntitiesByRoleFullDetails
      v-if="showEntitiesForRole"
      v-bind="entitiesForRoleProps"
      @entitiesByRoleModalClosed="closeModal">
    </EntitiesByRoleFullDetails>

    <RolesByEntityFullDetails
      v-if="showRolesForEntity"
      v-bind="rolesForEntityProps"
      @rolesByEntityModalClosed="closeModal">
    </RolesByEntityFullDetails>
  </div>
</template>

<script>
import Vue from 'vue'
import { CaldavService } from '@/api/BookingService'
import Slider from '@/components/common/Slider'
import { mapGetters } from 'vuex'
import EditUserProfileModal from './EditUserProfileModal'
import EditUserPasswordModal from './components/EditUserPasswordModal'
import { PASSWORD_REGEX } from '@/utils/regex'
import UserRoleDetails from '@/components/users/components/Roles/UserRoleDetails'
import EntitiesByRoleFullDetails from '@/components/users/components/Roles/components/EntitiesByRoleFullDetails'
import RolesByEntityFullDetails from '@/components/users/components/Roles/components/RolesByEntityFullDetails'
import Notifications from '@/components/users/components/Notifications/Index'
import SocketioService from "@/services/socketio.service";
import EventBus from "@/utils/EventBus";

const SCREENING_ACTIVITY = 3
export default {
  components: {
    RolesByEntityFullDetails,
    EntitiesByRoleFullDetails,
    UserRoleDetails,
    Slider,
    EditUserProfileModal,
    EditUserPasswordModal,
    Notifications
  },
  data () {
    return {
      isUpdatingProfile: false,
      entitiesForRoleProps: {},
      rolesForEntityProps: {},
      showUpdatePasswordModal: false,
      userDetails: null,
      oldPassword: '',
      newPassword: '',
      newPasswordConfirmation: '',
      deleteClicked: false,
      secondsToLogout: 3,
      expandDeleteAccount: true,
      showEntitiesForRole: false,
      showRolesForEntity: false,
      caldav: null,
      screening: {
        active: true,
        days_before: 1
      },
      screeningNotificationCreated: false,
      daysBefore: null,
      isEditingCaldav: true,
      isEditingScreeningDays: false
    }
  },
  computed: {
    ...mapGetters([
      'services'
    ]),
    userHasScreeningActivity: function () {
      if (!this.userDetails || !this.userDetails.userActivities) {
        return false
      }
      return this.userDetails.userActivities.find(userActivity => userActivity.activity_id === SCREENING_ACTIVITY)
    },
    validScreeningNotificationDaysBefore: function () {
      return this.daysBefore >= 1 && this.daysBefore <= 31
    },
    screeningNotificationMessage: function () {
      if (!this.screening.active) {
        return this.$t('profile.labels.no_email_notification')
      }
      let translatedMessage = this.screening.days_before > 1 ? 'profile.labels.email_notification_multiple_day' : 'profile.labels.email_notification_single_day'
      return this.$t(translatedMessage, { days: this.screening.days_before })
    },
    selectedUserLanguage: function () {
      switch (this.userDetails.language.toUpperCase()) {
      case 'PT':
        return this.$t('profile.labels.portuguese')
      case 'EN':
        return this.$t('profile.labels.english')
      case 'ES':
        return this.$t('profile.labels.spanish')
      }
    },
    agendaService: function () {
      return this.services.find(service => service.service === 'ebooking')
    },
    caldavUrl: function () {
      return `${this.agendaService.url}/caldav/${this.caldav.hash}`
    },
    userHasRoles: function () {
      return this.$auth.user().services.some(service => service.user_roles.length > 0)
    },
    projectManagersProfiles: function () {
      return ['Project Manager', 'Project Manager Evollu']
    },
    invalidPassword: function () {
      if (this.newPassword) {
        return !this.newPassword.match(PASSWORD_REGEX)
      }
      return false
    },
    nonMatchingPassword: function () {
      if (this.newPassword && !this.invalidPassword && this.newPasswordConfirmation) {
        return this.newPassword !== this.newPasswordConfirmation
      }
      return false
    }
  },
  watch: {
    secondsToLogout: function (value) {
      if (value === 0) {
        this.$auth.logout({
          redirect: { name: 'login' }
        })
      }
    }
  },
  methods: {
    closeModal: function () {
      this.showEntitiesForRole = false
      this.showRolesForEntity = false
    },
    cancelUpdateNumberDays: function () {
      this.isEditingScreeningDays = false
    },
    submitUpdateNumberDays: function () {
      this.screening.days_before = this.daysBefore
      this.updateScreeningEmailNotification()
      this.isEditingScreeningDays = false
    },
    editDaysBeforeNotification: function () {
      this.daysBefore = this.screening.days_before
      this.isEditingScreeningDays = true
    },
    updateScreeningEmailNotification: function () {
      this.$http({
        url: `${this.agendaService.url}/screeningnotification`,
        method: 'POST',
        data: this.screening
      }).then(() => {
        this.screeningNotificationCreated = true
        this.showToast(this.$t('profile.labels.screening_configuration_success'), this.$store.state.successToastOptions)
      }).catch((err) => {
        console.log(err)
        this.showToast(this.$t('profile.labels.error'), this.$store.state.errorToastOptions)
      })
    },
    editUserProfile: function () {
      this.isUpdatingProfile = true
    },
    passwordUpdated: function (payload) {
      this.showUpdatePasswordModal = false
      this.showToast(this.$t('profile.toast.password_success'), this.$store.state.successToastOptions)
    },
    profileUpdated: function (payload) {
      this.isUpdatingProfile = false
      Vue.i18n.set(payload.language)
      this.userDetails.language = payload.language
      this.$auth.user({
        ...this.$auth.user(),
        ...payload
      })
      this.getMyInfo()
    },
    updateCaldavState: function () {
      this.$http({
        url: this.agendaService.url + '/caldav/' + this.caldav.id,
        method: 'PATCH',
        data: { active: this.caldav.active }
      }).then((response) => {
        this.caldav = response.data.data
        this.showToast(this.$t('profile.labels.calendar_configuration_success'), this.$store.state.successToastOptions)
      }).catch((err) => {
        console.log(err)
      })
    },
    generateNewCaldav: function () {
      if (this.caldav) {
        CaldavService.refresh(this.caldav.id, { refresh: true })
          .then(caldav => {
            this.caldav = caldav
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    copyCaldavUrl: function () {
      const url = document.createElement('textarea')
      url.value = this.caldavUrl
      document.body.appendChild(url)
      url.select()
      document.execCommand('copy')
      document.body.removeChild(url)
      this.showToast(this.$t('profile.toast.caldav_copied'), this.$store.state.successToastOptions)
    },
    createCaldav: function () {
      CaldavService.create()
        .then(caldav => {
          this.caldav = caldav
        }).catch((err) => {
        console.log(err)
      })
    },
    closeEntitiesRoleModal: function () {
      this.showEntitiesForRole = false
      this.entitiesForRoleProps = {}
    },
    showEntitiesForRoleModal: function ({ entities, role }) {
      this.entitiesForRoleProps = {
        entities,
        role,
        user: this.userDetails
      }
      this.showEntitiesForRole = true
    },
    showRolesForEntityModal: function ({ roles, entity }) {
      this.rolesForEntityProps = {
        roles,
        entity,
        user: this.user
      }
      this.showRolesForEntity = true
    },
    cancelDeleteAccount: function () {
      this.deleteClicked = false
    },
    confirmDeleteAccount: function () {
      this.$http({
        url: this.$store.state.evollauth_server + '/users/' + this.$auth.user().id,
        method: 'DELETE'
      }).then((response) => {
        setTimeout(() => {
          SocketioService.disconnect()
          this.$auth.logout({
            redirect: { name: 'login' }
          })
        }, 300)
      }).catch((err) => {
        console.log(err)
      })
    },
    confirmDelete: function () {
      this.deleteClicked = true
      // this.$refs.deleteAccountModal.open()
    },
    getMyInfo: function () {
      let url = this.$store.state.evollauth_server + '/auth/me'
      this.$http({
        url: url
      }).then((response) => {
        this.userDetails = response.data
      }).catch((error) => {
        console.log(error)
      })
    },
    cancelChange: function () {
      //console.log('UPDATED')
      this.showUpdatePasswordModal = false
    },
    getProfile () {
      this.$http({
        url: this.audiology_server + '/users/' + this.$auth.user().id + '/profile'
      }).then((response) => {
        if (!response.data.data) return
        Vue.set(this.userDetails, 'profile', response.data.data)
      }).catch((error) => {
        console.log(error)
      })
    },
    getUserCaldav: function () {
      CaldavService.getUserCaldav()
        .then(caldav => {
          this.caldav = caldav
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  mounted () {
    if (this.$auth.check()) {
      this.userDetails = this.$auth.user()
      this.getUserCaldav()
    }

  },
  created() {
    EventBus.$on('openChangePasswordModal', () => {
      this.showUpdatePasswordModal = true
    })
  }
}
</script>

<style lang="scss">

.button-no-margin-left {
  margin-left: 0px !important;
}

/* .btn.btn-primary.btn-cancelar {
  background-color: #fff;
  color: #29c4a9;
} */

.form-check-label {
  opacity: 1 !important;
}

.tag-role {
  display: inline-flex;
}

.delete-account-wrapper {
  margin-top: 0.5rem;
  display: flex;
  justify-content: space-between;
  justify-items: center;
}

.bye-bye {
  font-size: 55px;
  display: flex;
  justify-content: center;
  font-weight: bold;
}

.is-bold {
  font-weight: bold;
}

.emails-configuration-list {
  margin-left: 1rem;
}
</style>

<style lang="scss" scoped>

.section-title {
  font-weight: 900;
  margin-left: 0.5rem;
  text-transform: uppercase;
}

.section-content {
  margin-top: 1rem;
  margin-left: 0.5rem;
}

.change-password-wrapper {
  border-top: 1px solid #d3d3d3;
  padding-top: 1rem;
}

.profile-details-label {
  text-transform: uppercase;
}

@media only screen and (max-width: 768px) {
  .btn-screening-notification-action {
    max-width: 60%;
  }

  .btn-screening-notification-action:last-child {
    margin-top: 1rem;
  }
}
</style>
